import React, {useState,useEffect,useContext, Component} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import {sex} from '../constants';
import {useFormValidator,Inputs,Scrollable,Message} from 'coaz-ui';
import client from '../client';
import { useNavigate } from 'react-router-dom';
import { PiUserDuotone } from 'react-icons/pi';
import {useIAgree,IAgree} from './IAgree';
import { useRef } from 'react';
import SubmitButton from './SubmitButton';
import { formatDate } from '../constants';

const Register = () => {
    const [userTypes,setUserTypes] = useState([]);
    const [userGroups,setUserGroups] = useState([]);
    const [districts,setDistricts] = useState([]);
    const [nationalities,setNationalities] = useState([]);
    const [professionalCategories,setProfessionalCategories] = useState([]);
    const [idTypes,setIdTypes] = useState([]);
    const [confirmPassword,setConfirmPassword] = useState('');
    const [message,setMessage] = useState({content:'',success:false});
    const [user,setUser] = useState({});
    const minWidth = 240;
    const [inputWidth,setInputWidth] = useState(minWidth);
    const [height,setHeight] = useState(0);
	const [loading,setLoading] = useState(true);
    const mainContainerRef = useRef(null);
    const inputsRef = useRef(null);
    const {request,errorMessage} = client;

    const navigate = useNavigate();
    
    const {iAgree,setIAgree} = useIAgree();

    const onChange = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUser({...user, [e.target.name]: null});
        } else {
            setUser({...user, [e.target.name]: value});
        }
    };

    const onUsername = (e) => {
        const value = e.target.value;
        if(value === '') {
            setUser({...user, name: ''});
        } else {
            setUser({...user, name: value.toLowerCase()});
        }
    };

    const onUserType = (e) => {
        const value = e.target.value;
        const userType = userTypes.find((userType) => {return userType.ref.id == value});
        if(userType) {
            setUser({...user,userType:userType});
        }
    };

    const onUserGroup = (e) => {
        const value = e.target.value;
        const userGroup = userGroups.find((userGroup) => {return userGroup.ref.id == value});
        if(userGroup) {
            setUser({...user,userGroup:userGroup});
        }
    };

    const onDateOfBirth = (e) => {
        const value = e.target.value;
        setUser({...user, dateOfBirth: new Date(value)});
    };

    const onDistrict = (e) => {
        const value = e.target.value;
        const district = districts.find((dist) => {return dist.ref.id == value});
        if(district) {
            setUser({...user,district:district});
        }
    };

    const onEmployed = (e) => {
        let value = !user.employed;
        setUser({...user,employed:value});
    }

    const submit = async () => {
        setMessage({content:'',success:false});
        if(user.password != confirmPassword) {
            setMessage({content:'Password and confirm password mismatch',success:false});  
            return;
        }
        setLoading(true);

        await request('POST','users',user)
        .then(async (response) => {
            setLoading(false);
            if(response && response.ref) {
                navigate(-1);
            } else {
                setMessage({content:errorMessage(response),success:false});
            } 
        })
        .catch((error) => {
            setMessage({content:errorMessage(error),success:false});
            setLoading(false);
        }); 
    }

    const [register,handleChange,handleSubmit,errors] = useFormValidator(submit);
    
    const inputs = [
        {
            label:'Username',
            type:'text',
            name:'username', 
            value:user && user.name?user.name:'',
            placeholder:'Enter username...',
            onChange:(e) => handleChange(e,onUsername),
            register:register,
            checks:['empty','username'],
            errors:errors
        },
        {
            label:'User Type',
            type:'select',
            options:() => {
                let options = [];
                userTypes.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'userType', 
            value:user && user.userType?user.userType.ref.id:'',
            placeholder:'Select user type...',
            onChange:(e) => handleChange(e,onUserType),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Password',
            type:'password',
            name:'password', 
            value:user.password,
            placeholder:'Enter password...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Confirm Password',
            type:'password',
            name:'confirmPassword', 
            value:confirmPassword,
            placeholder:'Confirm password...',
            onChange:(e) => handleChange(e,(e)=> setConfirmPassword(e.target.value)),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Firstname',
            type:'text', 
            name:'firstname',
            value:user && user.firstname?user.firstname:'',   
            placeholder:'Enter firstname...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Lastname',
            type:'text',
            name:'lastname', 
            value:user && user.lastname?user.lastname:'',
            placeholder:'Enter lastname...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Middlename',
            type:'text',
            name:'middlename', 
            value:user && user.middlename?user.middlename:'',
            placeholder:'Enter middlename...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Sex',
            type:'select',
            options:() => {
                let options = [];
                sex.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'sex', 
            value:user && user.sex?user.sex:'',
            placeholder:'Select sex...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Date of Birth',
            type:'date',
            name:'dateOfBirth', 
            value:user && user.dateOfBirth?formatDate(user.dateOfBirth,true):'',
            placeholder:'Pick date of birth...',
            onChange:(e) => handleChange(e,onDateOfBirth)
        },
        {
            label:'ID type',
            type:'select',
            options:() => {
                let options = [];
                idTypes.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'idType', 
            value:user && user.idType?user.idType:'',
            placeholder:'Select ID type...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'ID number',
            type:'text',
            name:'idNumber', 
            value:user && user.idNumber?user.idNumber:'',
            placeholder:'Enter ID number...',
            onChange:(e) => handleChange(e,onChange),
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Email',
            type:'text',
            name:'email',
            value:user && user.email?user.email:'',   
            placeholder:'Enter email...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        },
        {
            label:'Nationality',
            type:'select',
            options:() => {
                let options = [];
                nationalities.map((option,i) => options.push(<option key={i} value={option}>{option}</option>));
                return options;
            },
            name:'nationality', 
            value:user && user.nationality?user.nationality:'',
            placeholder:'Select nationality...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Phone 1',
            type:'text',
            name:'phone1', 
            value:user && user.phone1?user.phone1:'',
            placeholder:'Enter phone 1...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Phone 2',
            type:'text',
            name:'phone2', 
            value:user && user.phone2?user.phone2:'',
            placeholder:'Select phone2...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Physical address',
            type:'text',
            name:'physicalAddress', 
            value:user && user.physicalAddress?user.physicalAddress:'',
            placeholder:'Enter physical address...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Postal Address',
            type:'text',
            name:'postalAddress', 
            value:user && user.postalAddress?user.postalAddress:'',
            placeholder:'Enter postal address...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'District',
            type:'select',
            options:() => {
                let options = [];
                districts.map((option,i) => options.push(<option key={i} value={option.ref.id}>{option.name}</option>));
                return options;
            },
            name:'district', 
            value:user && user.district?user.district.ref.id:'',
            placeholder:'Select district...',
            onChange:(e) => handleChange(e,onDistrict)
        },
        {
            label:'Program',
            type:'text', 
            name:'program',
            value:user && user.program?user.program:'',   
            placeholder:'Enter program...',
            onChange:(e) => {handleChange(e,onChange)}
        },
        {
            label:'Institution',
            type:'text',
            name:'institution', 
            value:user && user.institution?user.institution:'',
            placeholder:'Enter Institution...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Professional Category',
            type:'select',
            options:() => {
                let options = [<option key={'n'} value={null}>None</option>];
                professionalCategories.map((option,i) => options.push(<option key={i}>{option}</option>));
                return options;
            },
            name:'professionalCategory', 
            value:user && user.professionalCategory?user.professionalCategory:'',
            placeholder:'Select professional category...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Employed',
            type:'checkbox', 
            name:'employed',
            value:user?user.employed:'',   
            onChange:(e) => onEmployed(e)
        },
        {
            label:'Employer',
            type:'text',
            name:'employer', 
            value:user && user.employer?user.employer:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter employer...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Employee Id',
            type:'text',
            name:'employeeId', 
            value:user && user.employeeId?user.employeeId:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter employee id...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Organizational Unit',
            type:'text',
            name:'organizationalUnit', 
            value:user && user.organizationalUnit?user.organizationalUnit:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter organizational unit...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Current Position',
            type:'text',
            name:'currentPosition', 
            value:user && user.currentPosition?user.currentPosition:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter current position...',
            onChange:(e) => handleChange(e,onChange)
        },
        {
            label:'Facility',
            type:'text',
            name:'facility', 
            value:user && user.facility?user.facility:'',
            disabled:user?!user.employed:true,
            placeholder:'Enter facility...',
            onChange:(e) => handleChange(e,onChange)
        }
    ]

    useEffect(() => {
        ( async () => {
            setLoading(true);
			let usr = {sex:sex[0]};
			try {
				let usrTypes = await request('GET','user-types')

				if(usrTypes && usrTypes.length > 0) {
					setUserTypes(usrTypes);
					usr.userType = usrTypes[0];
				}  else {
					setUserTypes([]);
				}

				let districts = await request('GET','districts',null,{bypassReservedCheck:true})
				
				if(districts && districts.length > 0) {
					districts.sort(function(a, b) {
						if (a.name < b.name) {
							return -1; // a comes before b
						}
						if (a.name > b.name) {
							return 1;  // b comes before a
						}
						return 0;      // names are equal, maintain relative order
					});
					setDistricts(districts);
					usr.district = districts[0];
				}  else {
					setDistricts([]);
				}

				let nations = await request('GET','nationalities')
				
				if(nations && nations.length) {
					setNationalities(nations);
					let zambia = nations.find(nation => {return nation.toLowerCase() === 'zambian'});
					usr.nationality = zambia?zambia:nations[0];
				}  else {
					setNationalities([]);
				}

				let categories = await request('GET','professional-categories')
			
				if(categories && categories.length) {
					setProfessionalCategories(categories);
				}  else {
					setProfessionalCategories([]);
				}
				
				let idtyps = await request('GET','id-types')
				
				if(idtyps && idtyps.length) {
					setIdTypes(idtyps);
					usr.idType = idtyps[0];
				}  else {
					setIdTypes([]);
				}
			} catch(error) {
				console.log(error);
				setMessage({content:errorMessage(error),success:false});
			} finally {
				setLoading(false);
				setUser(usr);
			}
        }
        )();

        const observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                if(mainContainerRef.current) {
                    let maxHeight = window.innerHeight * (90/100);
                    if(maxHeight < entry.target.offsetHeight) {
                        setHeight(maxHeight);
                    } else {
                        setHeight(0);
                    }
                }
            }
        });

        if(inputsRef.current) {
            observer.observe(inputsRef.current)
        }
            
        return () => {
            observer.disconnect();
        };
    },[]);

  return (
    <div ref={mainContainerRef} className='flex items-center justify-center w-full h-full p-4 overflow-hidden'>
        <div style={{height:!height || height == 0?'auto':height+'px', backdropFilter:'blur(20px)'}} 
            className='flex w-full md:w-[720px] bg-[rgba(255,255,255,.8)] p-4 shadow-2xl rounded-2xl overflow-hidden'>
            <Scrollable vertical={true}>
                <div ref={inputsRef} className='flex flex-col items-center w-full space-y-4 h-fit'>
                    <img src='/logo.png' className='w-32 h-32'/>
                    <div className='flex flex-row space-x-2 text-2xl'><p className='font-bold text-[rgba(0,175,240)]'>SELF</p><p className='font-light'>REGISTRATION</p></div>
                    <Inputs inputs={inputs} minWidth={minWidth} onSubmit={handleSubmit}/>
                    <IAgree iAgree={iAgree} setIAgree={setIAgree}/>
                    <SubmitButton onSubmit={handleSubmit} width={minWidth} disabled={!iAgree}/>
                    <Message message={message}/>
                </div>
            </Scrollable>
        </div>
    </div>
  )
}

export default Register